import { render, staticRenderFns } from "./packageEpcPh.vue?vue&type=template&id=dc406106&scoped=true"
import script from "./packageEpcPh.vue?vue&type=script&lang=js"
export * from "./packageEpcPh.vue?vue&type=script&lang=js"
import style0 from "./packageEpcPh.vue?vue&type=style&index=0&id=dc406106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc406106",
  null
  
)

export default component.exports